import { NumericFormat } from 'react-number-format'
import { ProfilePhoto } from 'components/ideal-core-ui'
import { FaCircle } from 'react-icons/fa'
import { DealsChart } from 'components/Contact/Contact/common/DealsChart'
import isEmpty from 'lodash/isEmpty'
import s from './ProfileInfoSection.scss'
import { getCurrency } from 'utils/authService'
import pluralize from 'pluralize'

const ProfileInfoSection = ({ photo, pipeline, proposalsNo }) => {
  const { totalValue, totalDeals, info } = pipeline
  const wonValue = info?.won?.value
  return (
    <section>
      <ProfilePhoto src={photo} className={s.photo} />
      <section className={s.mainInfo}>
        <div className={s.infoTitle}>
          <div className={s.value}>
            <NumericFormat
              displayType="text"
              thousandSeparator
              value={totalValue}
              prefix={getCurrency().symbol}
              title={totalValue}
            />
          </div>
          <div className={s.label}>Total Pipeline</div>
        </div>
        <div className={s.infoTitle}>
          <div className={s.value}>
            <NumericFormat
              displayType="text"
              thousandSeparator
              value={wonValue}
              prefix={getCurrency().symbol}
            />
          </div>
          <div className={s.label}>Won Opportunities</div>
        </div>
      </section>
      <section className={s.secondaryInfo}>
        <div className={s.secondaryItem}>
          <div className={s.value}>{totalDeals}</div>
          <div className={s.label}>Active Opportunities</div>
        </div>
        <div className={s.secondaryItem}>
          <div className={s.value}>{proposalsNo}</div>
          <div className={s.label}>Active Proposals</div>
        </div>
      </section>
      <section className={s.chartContainer}>
        <div className={s.value}>TOTAL CURRENT PIPELINE:</div>
        <div className={s.value}>
          {pluralize('opportunity', totalDeals, true)}
          <FaCircle className={s.circle} />
          <NumericFormat
            displayType="text"
            thousandSeparator
            value={totalValue}
            prefix={getCurrency().symbol}
          />
        </div>
        {!isEmpty(pipeline) && (
          <DealsChart chartWidth={270} chartHeight={370} pipeline={pipeline} />
        )}
      </section>
    </section>
  )
}

export default ProfileInfoSection
